import { z } from "zod";

const ids = z.array(z.string().min(1).max(100)).max(10000);
export const artistSelectorOrganizationSchema = z
  .object({
    order: ids,
    folders: z
      .array(
        z.object({
          id: z.string().uuid(),
          name: z.string().trim().min(1).max(80),
          artistIds: ids,
          collapsed: z.boolean(),
        }),
      )
      .max(100),
  })
  .superRefine((value, ctx) => {
    if (
      value.folders.reduce(
        (total, folder) => total + folder.artistIds.length,
        0,
      ) > 10000
    ) {
      ctx.addIssue({
        code: "custom",
        message: "At most 10,000 artists can be grouped.",
      });
    }
    for (const values of [
      value.order,
      value.folders.map((folder) => folder.id),
      value.folders.flatMap((folder) => folder.artistIds),
    ]) {
      if (new Set(values).size !== values.length) {
        ctx.addIssue({
          code: "custom",
          message: "Artists and folders must not be duplicated.",
        });
      }
    }
  });

export const artistSelectorPreferencesSchema = z.object({
  revision: z.number().int().min(0).max(2147483647),
  organization: artistSelectorOrganizationSchema,
});

export const artistSelectorSaveSchema = artistSelectorPreferencesSchema.extend({
  expectedUserId: z.string().min(1).max(128),
});
